import { render, staticRenderFns } from "./ForgotPasswordConfirm.vue?vue&type=template&id=1e5d2b7a&"
import script from "./ForgotPasswordConfirm.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports